export default __webpack_public_path__ + "static/media/finance-guide-personal-loan.8331c795.svg";